"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactSvg = require("react-svg");
var keycode = _interopRequireWildcard(require("../../../core/utils/keyCodes"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ModalCloseIcon = function ModalCloseIcon(_ref) {
  var closeFunc = _ref.closeFunc,
    closeIconLeftAligned = _ref.closeIconLeftAligned,
    icon = _ref.icon,
    className = _ref.className,
    elementLocator = _ref.elementLocator;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    _react.default.createElement("div", {
      onClick: function onClick(e) {
        return closeFunc(e);
      },
      className: className,
      "data-locator": elementLocator
    }, icon && _react.default.createElement(_reactSvg.ReactSVG, (0, _extends2.default)({
      className: (closeIconLeftAligned ? 'modal-icon-alignLeft' : 'modal-icon-alignRight') + " cmp-modal__close-icon",
      src: icon,
      tabIndex: 0
    }, {
      onKeyPress: function onKeyPress(e) {
        return e.charCode === keycode.ENTER ? closeFunc(e) : null;
      }
    })))
  );
};
ModalCloseIcon.defaultProps = {
  className: '',
  icon: '',
  closeIconLeftAligned: false,
  closeFunc: function closeFunc() {
    /* default closeFunc handler */
  },
  elementLocator: 'modal-close-icon'
};
var _default = ModalCloseIcon;
exports.default = _default;
module.exports = exports["default"];